// extracted by mini-css-extract-plugin
module.exports = {"main":"Products_main__zJmZ3","labelAuctions":"Products_labelAuctions__MaRbm","labelBuyNow":"Products_labelBuyNow__3Y8HD"};